import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { UserComponent } from './user/user.component';
import { SignUpComponent } from './user/sign-up/sign-up.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { AuthGuard } from './auth/auth.guard';
import { DiagnosticoComponent } from './diagnostico/diagnostico.component';
import { CuestionarioComponent } from './cuestionario/cuestionario.component';
import { SolucionComponent } from './solucion/solucion.component';
import { CongratsComponent } from './congrats/congrats.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DiagnosticosListaComponent } from './diagnosticos-lista/diagnosticos-lista.component';
import { SolucionDocumentComponent } from './solucion-document/solucion-document.component';
import { DashboardDiagnosticoComponent } from './dashboard-diagnostico/dashboard-diagnostico.component';
import { ForgotPasswordComponent } from './user/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './user/reset-password/reset-password.component';
import { ConfirmMailComponent } from './user/confirm-mail/confirm-mail.component';
import { ChangePasswordComponent } from './user/change-password/change-password.component';
import { TarjetacompletaComponent } from './tarjetacompleta/tarjetacompleta.component';

export const appRoutes: Routes = [
    { path: 'diagnostico' , component: DiagnosticoComponent, canActivate: [AuthGuard]},
    { path: 'cuestionario' , component: CuestionarioComponent, canActivate: [AuthGuard]},
    { path: 'soluciones' , component: SolucionComponent, canActivate: [AuthGuard]},
    { path: 'dashboard' , component: DashboardComponent, canActivate: [AuthGuard]},
    { path: 'dashboard-Diagnostico' , component: DashboardDiagnosticoComponent, canActivate: [AuthGuard]},
    { path: 'congrats' , component: CongratsComponent, canActivate: [AuthGuard]},
    { path: 'account' , component: SolucionComponent, canActivate: [AuthGuard]},
    { path: 'signoff' , component: SolucionComponent, canActivate: [AuthGuard]},
    { path: 'webinar' , component: SolucionComponent, canActivate: [AuthGuard]},
    { path: 'openlab' , component: SolucionComponent, canActivate: [AuthGuard]},
    { path: 'solutiondoc' , component: SolucionDocumentComponent, canActivate: [AuthGuard]},
    { path: 'tarjetacompleta' , component: TarjetacompletaComponent, canActivate: [AuthGuard]},
    { path: 'library' , component: SolucionComponent, canActivate: [AuthGuard]},
    { path: 'null', redirectTo: '/login' },
    // { path: '**', redirectTo: '/' },
    // { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'signup', component: SignUpComponent },
    { path: 'login', component: SignInComponent  },
    { path: 'forgot-password' , component: ForgotPasswordComponent , pathMatch: 'full'},
    { path: 'change-password' , component: ChangePasswordComponent },
    { path: 'reset-password/token/:token' , component: ResetPasswordComponent},
    { path: 'confirm/mail/id/:id/token/:token' , component: ConfirmMailComponent},
    { path : '', redirectTo: '/login', pathMatch : 'full'},
    // { path: '**', redirectTo: '/' }
];



// WEBPACK FOOTER //
// ./src/app/routes.ts